import { render, staticRenderFns } from "./ProviderTable.vue?vue&type=template&id=38d4447b&"
import script from "./ProviderTable.vue?vue&type=script&lang=js&"
export * from "./ProviderTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports